import { MatxLoadable } from "matx";

const Dashboard = MatxLoadable({
  loader: () => import("../views/dashboard"),
});

const dashboardRoutes = [
  {
    path: "/dashboard",
    component: Dashboard,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default dashboardRoutes;
